import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_DEPARTMENTS } from "../../../utils/constants";
import { DepartmentInterface } from "../../../models/TicketModule/Department";
import departmentService from "../../../services/ticketService/departmentService";

const useDepartment = (page: number, pageSize: number) =>
  useQuery<DepartmentInterface[], Error>({
    queryKey: [
      CACHE_KEY_DEPARTMENTS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => departmentService.GetAll(page, pageSize),
  });

export default useDepartment;
